.root {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
}

.headerRow {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.sectionPadding {
  padding: 16px;
}

.monitorRow {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.backlineChips {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
}

.stageRow {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.hospitalityRow {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.drinksSection {
  margin-top: 16px;
}

.drinksChips {
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.notesSection {
  margin-top: 16px;
}

.requirementRow {
  margin-bottom: 4px;
}

.requirementInner {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.chipMinWidth {
  min-width: 70px;
}

.noteMargin {
  margin-left: 80px;
}

.fontBold {
  font-weight: var(--tuna-typography-fontWeight-bold);
}
